import { objectValues } from '@hsp/utilities';

import { ICategoryBySource } from '@t/api/audience/data-points/source.model';
import { IResult } from '@t/api/common';
import { DataDictionarySource } from '@t/api/data-dictionary/data-dictionary-source.type';

import { Uri } from 'constants/uri';

import { BaseHttpService } from './http/base-http.service';

class DataDictionaryService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.DataDictionary) as string[] });
  }

  getDataPoints(source?: string, category?: string, cancel = false): Promise<IResult<ICategoryBySource[]>> {
    const url = Uri.DataDictionary.DataPoints;

    return this.get({
      ...this.defaultRequestConfig(url, cancel),
      params: { category, source },
    });
  }

  getSources(cancel = false): Promise<IResult<DataDictionarySource[]>> {
    const url = Uri.DataDictionary.Sources;

    return this.get(this.defaultRequestConfig(url, cancel));
  }

  getTextValues(source: string, name: string, cancel = false): Promise<IResult<string[]>> {
    const url = Uri.DataDictionary.TextValues;

    return this.get({
      ...this.defaultRequestConfig(url, cancel),
      params: { name, source },
    });
  }
}

export const dataDictionaryService = new DataDictionaryService();
